export default "__VITE_ASSET__29df80d7__"